import React, { useEffect, useState } from "react";
import UserSideNav from "../../components/user/UserSideNav";
import UserHeader from "../../components/user/UserHeader";
import SmartDataTable from "../../components/shared/SmartDataTable";
import { WalletCards, Loader2 } from "lucide-react";
import { paymentsApi } from "../../services/api";

function fmtDate(d) {
  return d ? new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";
}

function fmt(n) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
}

export default function Payments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    paymentsApi.getMyPayments()
      .then((res) => setPayments(res.data.data || []))
      .catch((err) => setError(err.response?.data?.message || "Failed to load payments."))
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    { name: "Date", selector: (row) => row.createdAt || "", sortable: true, cell: (row) => fmtDate(row.createdAt) },
    { name: "Description", selector: (row) => row.description || row.type || "", sortable: true, cell: (row) => <strong>{row.description || `${row.type === "subscription" ? "Subscription" : "Pool Entry"}`}</strong>, grow: 1.6 },
    { name: "Type", selector: (row) => row.type || "", sortable: true, cell: (row) => <span style={{ textTransform: "capitalize" }}>{row.type?.replace("_", " ")}</span> },
    { name: "Amount", selector: (row) => row.amount || 0, sortable: true, cell: (row) => <b className="table-primary">{fmt(row.amount)}</b> },
    { name: "Status", selector: (row) => row.status || "", sortable: true, cell: (row) => <span className={`table-status ${row.status === "failed" ? "danger" : row.status === "pending" ? "warn" : "live"}`}>{row.status}</span> },
  ];

  return (
    <div className="user-shell">
      <UserSideNav />
      <div className="user-app">
        <UserHeader />
        <main className="user-main">
          <div className="welcome-block">
            <div>
              <div className="page-kicker">Payments</div>
              <h1>Payment History</h1>
              <p>All charges and transactions linked to your account.</p>
            </div>
          </div>

          {error && <div className="auth-error">{error}</div>}

          {loading ? (
            <div className="page-loading"><Loader2 size={28} className="spin" /><span>Loading payments…</span></div>
          ) : payments.length === 0 ? (
            <div className="empty-state"><WalletCards size={36} /><p>No payment history yet.</p></div>
          ) : (
            <section className="section-block">
              <div className="section-heading">
                <h2><WalletCards size={20} /> Transactions</h2>
                <span style={{ color: "var(--muted)", fontSize: 13 }}>{payments.length} records</span>
              </div>
              <SmartDataTable
                columns={columns}
                data={payments}
                loading={false}
                searchFields={["description", "type", "status", "createdAt"]}
                searchPlaceholder="Search payments by type, status, description..."
                emptyMessage="No payment history yet."
                paginationPerPage={25}
              />
            </section>
          )}
        </main>
      </div>
    </div>
  );
}
